<template>
  <div>
    <div class="normalHeader" >
      <img src="@/assets/img_szdw.png" class="bg" />
    </div>
    <div class="panel">
      <div class="w1200">
        <div class="breader">
          <router-link to="/" class="breaderLink">首页</router-link>
          <span> / </span>
          <span class="breaderNow">师资队伍</span>
        </div>
        <div class="teacherList">
          <div class="teacherCard" v-for="(item, index) in szlist" :key="index">
            <img :src="require('@/assets/szdw/' + item.picB)" class="avatar" />
            <span class="name">{{item.name}}</span>
            <span class="from">{{item.from}}</span>
            <p class="desc">{{item.desc}}</p>
            <span class="btn" @click="teacherDetail(item)">详情</span>
          </div>
        </div>
      </div>
    </div>
    <teacherPop v-if="teacherPopShow" :item="teacherItem" v-on:close="popHide"></teacherPop>
  </div>
</template>

<script>

import teacherPop from '@/components/teacherPop.vue'
export default {
  name: 'szdw',
  components: {
    teacherPop,
  },
  data() {
    return {
      teacherItem: {},
      teacherPopShow: false,
      routerFrom: {},
      routerTo: {},
      szlist: [{
          id: 1,
          name: '张进',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院赛事辅导专家，威盛人工智能研究院金牌培训讲师，具有多年丰富的国家级赛事辅导经验，多次承担教育部白名单赛事人工智能项目赛事培训工作。每年为全国各省级赛区提供超50场线上及线下培训，辅导学员多次获得国家级赛事一等奖，擅长作品创意及制作、多领域人工智能技术的交叉设计。',
          picB: 'sz_img1.png',
          pic: 'sz_img_s1.png'
        },{
          id: 2,
          name: '冯如振',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院技术工程师、高级讲师、高级嵌入式软件工程师、高级系统集成管理工程师，曾担任中国航天科技空气动力技术研究院无人机工程师、东部战区陆航直升机旅无人机技术讲师、国网高级技术顾问，专注技术领域包括航空航天、人工智能、计算机科学等领域，具备多年高科技智能硬件产品研发经验及丰富的技术培训经验。',
          picB: 'sz_img2.png',
          pic: 'sz_img_s2.png'
        },{
          id: 3,
          name: '李向君',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院技术支持专家、高级讲师具有丰富的现场支持经验，具有人工智能软硬件开发和调优方面、赛事指导培训等实际经验，为全国各地及国家级活动提供现场技术支持工作及赛事指导工作。',
          picB: 'sz_img3.png',
          pic: 'sz_img_s3.png'
        },{
          id: 4,
          name: '王宇',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院技术解决方案专家、高级讲师，威盛人工智能研究院技术研发专家。近十年人工智能软硬件研究经验，参与创造栗多个产品设计研发项目，熟悉机器学习常用算法，熟悉各种深度学习模型，熟悉常用的深度学习开源软件，为上百所中小学学校开展人工智能课程提供技术解决方案。',
          picB: 'sz_img4.png',
          pic: 'sz_img_s4.png'
        },{
          id: 5,
          name: '刘凯铭',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院技术支持专家、高级讲师，具有丰富的现场支持经验，具有人工智能软硬件开发和调优方面等实际经验，为全国各地及国家级活动提供现场技术支持工作。每年为全国各省市提供超过50场线上及线下技术培训。河南鹤壁首批人工智能试点学校教师培训主讲教师。',
          picB: 'sz_img5.png',
          pic: 'sz_img_s5.png'
        },{
          id: 6,
          name: '任延涛',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院技术支持专家、高级讲师具有丰富的现场支持经验，具有人工智能软硬件开发和调优方面、课程研发等实际经验，为全国各地及国家级活动提供现场技术支持工作及课程研发工作。',
          picB: 'sz_img6.png',
          pic: 'sz_img_s6.png'
      }],
    }
  },
  watch: {
    $route(to, from) {
      this.routerFrom = from
      this.routerTo = to
      console.log(this.routerTo)
    }
  },
  mounted() {
  },
  methods: {
    teacherDetail(_item) {
      this.teacherItem = _item
      this.teacherPopShow = true
    },
    popHide() {
      this.teacherItem = {}
      this.teacherPopShow = false
    }
  }
}
</script>

<style scoped>
* {box-sizing: border-box;}
.normalHeader{width: 100%;height: 260px;}
.normalHeader .bg{display: block;width: 100%;height: 100%;object-fit: cover;}
.panel{width: 100%;height: auto;position: relative;padding-bottom: 100px;background-color: #F8F9FD;}
.w1200{width: 1200px;margin: 0 auto;}
.breader{padding-top: 30px;padding-bottom: 59px;}
.breader span{display: inline-block;color: #8C8C8C;font-size: 14px;line-height: 20px;margin-left: 8px;margin-right: 8px;}
.breader .breaderLink{display: inline-block;color: #8C8C8C;font-size: 14px;line-height: 20px;margin: 0;}
.breader .breaderLink:hover{color: #0E4AFA}
.breader .breaderNow{display: inline-block;color: #151515;font-size: 14px;line-height: 20px;margin: 0;}

.teacherList{font-size: 0;}
.teacherCard{display: inline-block;width: 384px;height: 588px;margin-right: 24px;margin-bottom: 59px;background-color: #fff;box-shadow: 0px 0px 14px 0px rgba(78,112,163,0.2);border-radius: 10px;position: relative;}
.teacherCard:nth-child(3n){margin: 0;}
.teacherCard .avatar{width: 100%;height: 275px;object-fit: cover;display: block;margin-bottom: 20px;}
.teacherCard .name{display: block;text-align: center;color: #222;font-size: 36px;font-weight: bold;margin-bottom: 10px;}
.teacherCard .from{display: block;text-align: center;color: #666;font-size: 20px;margin-bottom: 20px;}
.teacherCard .desc{display: block;text-align: justify;color: #666;font-size: 18px;line-height: 30px;padding-left: 47px;padding-right: 47px;
  overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;word-wrap: break-word;-webkit-hyphens: auto;hyphens: auto;
}
.teacherCard .btn{display: block;width: 112px;height: 36px;border-radius: 18px;border: 1px solid #0E4AFA;line-height: 36px;text-align: center;color: #0E4AFA;font-size: 14px;
  position: absolute;bottom: 40px;left: 136px;cursor: pointer;
}
.teacherCard .btn:hover{opacity: 0.5}
</style>
